import type { CollectionHistoryJSONObject } from '@ikegps/core-api';
import { IkeRestDepartment } from '../rest.department';
import { IkeRestObject } from './base';

/**
 * Retrieves Collection objects from the history_FormData table through the Collection query endpoint.
 * Relies on a feature of the query endpoint that falls back to querying the history table if no results are found.
 * The 'originalId' field is only present on objects in history_FormData, so filtering on 'originalId' will return historical results.
 */
export class IkeObjectCollectionHistory extends IkeRestObject<CollectionHistoryJSONObject> {
	className = 'CollectionHistory' as const;
	actionName = 'collectionHistory';
	object: CollectionHistoryJSONObject;

	constructor() {
		super();
		this.cacheKeys['uuid'] = true;
		this.cacheKeys['revision'] = true;
	}

	override updateCache<K extends keyof CollectionHistoryJSONObject>(
		key: K,
		result: CollectionHistoryJSONObject,
		rest: IkeRestDepartment
	) {
		super.updateCache(key, result, rest);

		this.cacheIfLatest('uuid', result, rest);
		this.cacheIfLatest('revision', result, rest);
	}
}
